import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface LookupProviderByIdPayload {
  id: string;
  serverType?: 'equator' | 'capricorn';
  clinicId?: string;
}

export const lookupProviderByIdApi = createAsyncThunk(
  'hl7/lookupProviderById',
  async (payload: LookupProviderByIdPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const searchParams = new URLSearchParams();
      searchParams.set('id', payload.id);
      if (payload.serverType) searchParams.set('serverType', payload.serverType);
      if (payload.clinicId) searchParams.set('clinicId', payload.clinicId);
      const response = await fetch(
        `${HL7.PROVIDER_LOOKUP_BYID}?${searchParams.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Lookup failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
